import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  createAction,
  configureStore,
} from "@reduxjs/toolkit";
import { Middleware, MiddlewareAPI, Dispatch } from "redux";
import {
  Content,
  ContentGroup,
  ContentOptionFavorite,
  ContentOptionFavorited,
  ReadingListItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { AppDispatch, RootState } from "..";
import { ContentService, UserDataService } from "../../services";
import {
  RemoteUserData,
  TagData,
} from "../../services/userData/IUserDataService";
import common, { commonSlice } from "./common";
import { contentDetail, contentSlice } from "./contentSlice";
import { userSlice } from "./userSlice";
import {
  RemoteContentDetail,
  RemoteContentReference,
} from "../../services/contents/IContentService";

interface UserDataState {
  historyReading?: string[];
  worksToReview?: string[];
  reading?: ContentGroup;

  tags: TagData[];
  sharedTags: TagData[];
  activeTagUid?: string;

  ///userdata
  userData: RemoteUserData[];
  userDataShared: RemoteUserData[];
  playerObserver?: {
    userInteraction?: any;
    onBack?: boolean;
  };
}

const initialState: UserDataState = {
  tags: [],
  sharedTags: [],
  userDataShared: [],
  ///userdata
  userData: [],
  playerObserver: {},
};

interface TagContentLink {
  content: Content;
  tag: TagData;
}

interface RateContent {
  content: Content;
  rate: number;
}

///Tags

const loadTags = createAsyncThunk("userdata/readinglist/available", () =>
  UserDataService.TagsAvailable()
);

const loadSharedTags = createAsyncThunk(
  "userdata/readinglist/shared/available",
  () => UserDataService.TagsSharedAvailable()
);

const subscribeTag = createAsyncThunk(
  "userdata/readinglist/shared/subscribe",
  (code: string) => UserDataService.TagSubscribe(code)
);

const createTag = createAsyncThunk("readinglist/remote/add", (tag: TagData) =>
  UserDataService.TagCreate(tag)
);

const updateTag = createAsyncThunk(
  "readinglist/remote/update",
  (tag: TagData) => UserDataService.TagUpdate(tag)
);

const deleteTag = createAsyncThunk(
  "readinglist/remote/delete",
  (tag: TagData) => UserDataService.TagDelete(tag)
);

/// UserData

const loadUserData = createAsyncThunk("userdata/available", () =>
  UserDataService.UserDataAvailable()
);

const loadUserDataShared = createAsyncThunk(
  "userdata/readinglist/shared/content",
  () => UserDataService.UserDataAvailableShared()
);

// const readingListFromContent = createAsyncThunk("userdata/readinglist/fromcontent", (content:Content) => UserDataService.ReadingListFromContent(content));

const insertContentInTag = createAsyncThunk(
  "userdata/readinglist/insert",
  (data: TagContentLink) =>
    UserDataService.InsertContentInTagt(data.content, data.tag)
);

const removeContentFromTag = createAsyncThunk(
  "userdata/readinglist/remove",
  (data: TagContentLink) =>
    UserDataService.RemoveContentFromTag(data.content, data.tag)
);

// Evaluate
export const postUserEvaluation = createAsyncThunk(
  "review/managedContent",
  (data: RateContent) =>
    UserDataService.PostUserEvaluation(data.content.uid, data.rate)
);
export const updateEvaluation = createAsyncThunk(
  "review/managedContent/update",
  (data: { uid: string, note: number }) =>
    UserDataService.UpdateUserEvaluation(data.uid, data.note)
);
export const deleteUserEvaluation = createAsyncThunk(
  "review/managedContent/remove",
  (reviewUid: string) =>
    UserDataService.DeleteUserEvaluation(reviewUid)
);

///contents download

const internalDownloadContentReference = createAsyncThunk(
  "content/reference/download",
  (contentReferenceUid: string) =>
    UserDataService.ContentDownload(contentReferenceUid)
);

const internalDeleteContentReference = createAsyncThunk(
  "content/reference/delete",
  (contentReferenceUid: string) =>
    UserDataService.ContentDelete(contentReferenceUid)
);

export const reloadUserData = createAction("userData/load");

export const FavoritesInternalTag = "###InternalFavorites###";

export const insertInFavorite = createAction<Content>("favorite/add");

export const removeFromFavorite = createAction<Content>("favorite/remove");

export const createTagPage = createAction("readinglist/add");

export const loadTag = createAction<string>("reading/load");

export const updateActiveTag = createAction<any>("reading/update");

export const searchAndSubscribeTag = createAction<any>("reading/subscribe");

export const shareCode = createAction<any>("reading/share");

export const removeActiveTag = createAction("reading/remove");

export const editTagByUid = createAction<string>("reading/edit");

export const insertTagShared = createAction<string>("userdata/shared");

export const insertInTagActiveContent = createAction<string>(
  "userdata/content/tag/insert"
);

export const removeFromTagActiveContent = createAction<string>(
  "userdata/content/tag/remove"
);

export const rateActiveContent = createAction<number>(
  "userdata/content/rating"
);
export const unRateActiveContent = createAction<string>(
  "userdata/content/rating/delete"
);

export const historyContents = createAsyncThunk(
  "contents/historyContents",
  () => ContentService.HistoryContents()
);

export const getReviewContents = createAsyncThunk(
  "contents/reviewContents",
  () => ContentService.ReviewContents()
);

export const downloadedContents = createAsyncThunk("content/downloaded", () =>
  UserDataService.ContentDownloaded()
);

export const downloadedContentsWithoutAlert = createAsyncThunk("content/downloaded", () =>
  UserDataService.ContentDownloaded()
);

export const downloadContentReference =
  createAction<string>("content/download");

export const deleteContentReference = createAction<string>("content/delete");

export const loadPlayerObserver = createAction("player/observer");

export const userDataSlice = createSlice({
  name: "userDataSlice",
  initialState,
  reducers: {
    resetState: () => initialState,

    cleanData: (state) => {
      state.activeTagUid = undefined;
      state.historyReading = undefined;
      state.worksToReview = undefined;
      state.userData = [];
      state.tags = [];
    },
    activeTagUid: (state, data: PayloadAction<string>) => {
      // const activeList = state.readingListAvailable.find(p=> p.uid == data.payload.uid);
      state.activeTagUid = data.payload;
    },
    runPlayerObserver: (state, data: PayloadAction<any>) => {
      state.playerObserver = data.payload
    }
  },
  extraReducers: (builder) => {
    ///reading list
    builder.addCase(historyContents.fulfilled, (state, action) => {
      state.historyReading = action.payload.map((p) => p.uid);
      //todo: atualizar lista geral de conteúdos
    });
    builder.addCase(getReviewContents.fulfilled, (state, action) => {
      state.worksToReview = action.payload.map((p) => p.uid);
      //todo: atualizar lista geral de conteúdos
    });
    ///userdata
    builder.addCase(loadUserData.fulfilled, (state, action) => {
      state.userData = action.payload;
    });

    builder.addCase(loadUserDataShared.fulfilled, (state, action) => {
      state.userDataShared = action.payload;
    });

    builder.addCase(insertContentInTag.fulfilled, (state, action) => {
      var data = { ...action.payload };
      state.userData = state.userData.filter(
        (p) => p.uid != data.uid && p.uid != action.meta.requestId
      );
      state.userData.push(data);
    });

    builder.addCase(insertContentInTag.pending, (state, action) => {
      state.userData.push({
        uid: action.meta.requestId,
        contextType: "ManagedContent",
        targetType: "ManagedContent",
        contextUid: action.meta.arg.content.uid,
        targetUid: action.meta.arg.content.uid,
        tags: [action.meta.arg.tag],
      });
    });

    builder.addCase(insertContentInTag.rejected, (state, action) => {
      state.userData = state.userData.filter(
        (p) => p.uid != action.meta.requestId
      );
    });

    builder.addCase(removeContentFromTag.fulfilled, (state, action) => {
      state.userData = [
        ...state.userData.filter(
          (p) => action.payload?.find((r) => r.uid == p.uid) == undefined
        ),
        ...action.payload,
      ];
    });

    //tags

    builder.addCase(loadSharedTags.fulfilled, (state, action) => {
      state.sharedTags = action.payload;
    });

    builder.addCase(loadTags.fulfilled, (state, action) => {
      state.tags = action.payload;
    });

    builder.addCase(createTag.fulfilled, (state, action) => {
      const list = state.tags;
      const tag = action.payload;

      if (!tag.contents) tag.contents = [];

      list?.push(tag);

      state.tags = list;
    });

    builder.addCase(updateTag.fulfilled, (state, action) => {
      var current = state.tags.find((p) => p.uid === action.payload.uid);
      var data = action.payload;

      if (current) {
        data = { ...current, ...data };
        state.tags = state.tags.filter((p) => p.uid !== current?.uid);
      }

      state.tags.push(data);
    });

    builder.addCase(deleteTag.pending, (state, action) => {
      var listUpdated = state.tags.filter(
        (item) => item.uid !== action.meta.arg.uid
      );
      state.tags = listUpdated;
    });

    builder.addCase(deleteTag.rejected, (state, action) => {
      const current = state.tags;
      current?.push(action.meta.arg);

      state.tags = current;
    });
  },
});

export const middleware: Middleware =
  (store: MiddlewareAPI<AppDispatch, RootState>) =>
  (next: Dispatch) =>
  async (action: PayloadAction<any>) => {
    const state = store.getState();

    if (commonSlice.actions.changeState.match(action) && action.payload == "initializing")
    {
      store.dispatch(historyContents());
    }


    if (userSlice.actions.activeUser.match(action)) {
      if (action.payload) {
        // store.dispatch(historyContents());
        // store.dispatch(getReviewContents());
        store.dispatch(loadUserData());
        store.dispatch(loadUserDataShared());
        store.dispatch(loadTags());
        store.dispatch(loadSharedTags());
      } else {
        store.dispatch(userDataSlice.actions.cleanData());
      }

      if (state.commonState.runningInMobile) {
        store.dispatch(downloadedContentsWithoutAlert());
      }
    }

    if(loadPlayerObserver.match(action)) {
      store.dispatch(userDataSlice.actions.runPlayerObserver(action.payload))
    }
    if(unRateActiveContent.match(action)) {
      if(state.contentState.activeReview) {
        store.dispatch(deleteUserEvaluation(state.contentState.activeReview))
        .then(() => {
          if(state.contentState.activeContentUid) {
            store.dispatch(contentDetail(state.contentState.activeContentUid))
          }
        })
      }
    };
    if (rateActiveContent.match(action)) {
      var content = state.contentState.allContents.find(
        (p) => p.uid == state.contentState.activeContentUid
      );

      if (content) {
        if(state.contentState.activeReview) {
          store.dispatch(updateEvaluation({ 
            uid: state.contentState.activeReview,
            note: action.payload
          }))     
          .then(() => {
            if (content) store.dispatch(contentDetail(content.uid));
          });
        }
        else {
          store
            .dispatch(
              postUserEvaluation({ content: content, rate: action.payload })
            )
            .then(() => {
              if (content) store.dispatch(contentDetail(content.uid));
            });
        }
      }
    }

    if (createTagPage.match(action)) {
      store.dispatch(userDataSlice.actions.activeTagUid("-1"));
      store.dispatch(editTagByUid("-1"));
    }

    if (editTagByUid.match(action)) {
      store.dispatch(userDataSlice.actions.activeTagUid(action.payload));
    } else if (updateActiveTag.match(action) && action.payload.name) {
      const currentTag = state.userDataState.tags.find(
        (p) => p.uid === state.userDataState.activeTagUid
      );
      const updatedTag: TagData = { ...currentTag, ...action.payload };

      if (updatedTag?.uid === "-1" || updatedTag.uid === undefined) {
        store
          .dispatch(createTag(updatedTag))
          .unwrap()
          .then((tag) => {
            console.log(updatedTag);
            updatedTag.contents?.forEach((content) =>
              store.dispatch(insertContentInTag({ content: content, tag: tag }))
            );
            store.dispatch(editTagByUid(tag.uid));
            store.dispatch(commonSlice.actions.showAlert({ 
              title: "Lista de leitura",
              show: true, 
              description: "Lista criada com sucesso."
            }))
          });
      } else if (updatedTag) {
        var userDatas = state.userDataState.userData.filter(
          (u) => u.tags?.find((t) => t.uid == updatedTag.uid) != undefined
        );
        var newContents = updatedTag.contents?.filter(
          (p) => userDatas?.find((u) => u.contextUid === p.uid) === undefined
        );
        var removeContents = userDatas?.filter(
          (p) =>
            updatedTag.contents?.find((cp) => cp.uid === p.contextUid) ===
            undefined
        );

        if (!newContents?.length && !removeContents?.length) {
          store.dispatch(commonSlice.actions.showAlert({ 
            title: "Lista de leitura",
            show: true, 
            description: "Lista editada com sucesso."
          }))
        };

        console.log("newContents", newContents);
        console.log("removeContents", removeContents);
        newContents?.forEach((c) =>
          store.dispatch(insertContentInTag({ content: c, tag: updatedTag }))
        );
        removeContents?.forEach((c) => {
          var removeContent = state.contentState.allContents.find(
            (ac) => ac.uid == c.contextUid
          );
          if (removeContent)
            store.dispatch(
              removeContentFromTag({ content: removeContent, tag: updatedTag })
            );
        });

        store.dispatch(updateTag(updatedTag));
      }
    } else if (loadTags.fulfilled.match(action)) {
      var favoriteTag = action.payload.find(
        (p) => p.name == FavoritesInternalTag
      );
      if (!favoriteTag)
        store.dispatch(createTag({ name: FavoritesInternalTag, uid: "fav" }));
    } else if (removeActiveTag.match(action)) {
      const currentTag = state.userDataState.tags.find(
        (p) => p.uid === state.userDataState.activeTagUid
      );
      if (currentTag) {
        store.dispatch(deleteTag(currentTag));
        store.dispatch(commonSlice.actions.backPage());
        store.dispatch(commonSlice.actions.showAlert({ 
          title: "Lista de leitura",
          description: "Lista de leitura removida com sucesso.",
          show: true,
        }))
      }
    } else if (loadTag.match(action)) {
      const tag = state.userDataState.tags.find(
        (p) => p.uid === action.payload
      );
      if (tag)
        store.dispatch(userDataSlice.actions.activeTagUid(action.payload));
    }

    if (insertInTagActiveContent.match(action)) {
      var content = state.contentState.allContents.find(
        (p) => p.uid == state.contentState.activeContentUid
      );
      var tag = state.userDataState.tags.find((p) => p.uid == action.payload);
      console.log(content, tag);
      if (content && tag) store.dispatch(insertContentInTag({ content, tag }));
    } else if (removeFromTagActiveContent.match(action)) {
      var content = state.contentState.allContents.find(
        (p) => p.uid == state.contentState.activeContentUid
      );
      var tag = state.userDataState.tags.find((p) => p.uid === action.payload);
      if (content && tag)
        store.dispatch(removeContentFromTag({ content, tag }));
    }

    if (createTag.fulfilled.match(action)) {
      store.dispatch(loadTags());
    }

    if(reloadUserData.match(action)) {
      store.dispatch(loadUserData())
    }
    ///favorites
    if (insertInFavorite.match(action)) {
      var data = action.payload;
      var tag = state.userDataState.tags.find(
        (p) => p.name == FavoritesInternalTag
      );
      if (data && tag)
        store.dispatch(insertContentInTag({ content: data, tag })).unwrap()
        .catch(() => {
          store.dispatch(commonSlice.actions.showAlert({ 
            description: "Ocorreu um erro ao tentar inserir nos favoritos.",
            show: true,
            title: "Favoritos",
          }))
        })
    }

    if (removeFromFavorite.match(action)) {
      const isWeb = window.innerWidth > 1024;
      const data = action.payload;
      const title = data.title && isWeb ? data.title : "Excluir conteúdo";

      const tag = store
        .getState()
        .userDataState.tags.find((p) => p.name === FavoritesInternalTag);
      store.dispatch(
        commonSlice.actions.showAlert({
          title: title,
          description: "Deseja excluir este e-book de seus favoritos?",
          show: true,
          buttons: [
            {
              label: "Excluir",
              callback: () =>
                tag &&
                store.dispatch(
                  removeContentFromTag({ content: data, tag: tag })
                ),
            },
          ],
        })
      );
    }

    //downloads

    if (
      commonSlice.actions.runningInMobile.match(action) &&
      action.payload == true
    ) {
      console.log("in mobile");
      store.dispatch(downloadedContentsWithoutAlert());
    }

    // if (downloadContent.match(action) || deleteContent.match(action))
    // {
    //   // console.log("download content: ",action.payload);

    //   var actionTarget = downloadContent;
    //   if (deleteContent.match(action)) actionTarget = deleteContent;

    //   store.dispatch(contentDetail(action.payload.uid))
    //     .unwrap()
    //     .then(rcontent=> {
    //       rcontent.references?.forEach(reference=> store.dispatch(actionTarget(reference.uid)));
    //     });
    // }

    if (downloadContentReference.match(action)) {
      store.dispatch(internalDownloadContentReference(action.payload));
      store.dispatch(
        commonSlice.actions.showAlert({
          title: "Fazendo download...",
          description: "",
          show: true,
        })
      );
    }

    if (downloadedContents.fulfilled.match(action)) {
      var showAlert =
        action.payload?.filter((contentUpdated) => {
          var completed = contentUpdated?.references?.filter(
            (r) => r.downloadProgress == 100
          );
          var lastContent = state.contentState.allContents.find(
            (c) => c.uid == contentUpdated.uid
          );

          if (!lastContent) return false;

          for (var reference of lastContent.references ?? []) {
            var newReferente = completed?.find((p) => p.uid == reference.uid);
            if (
              !newReferente ||
              reference.downloadProgress == newReferente.downloadProgress
            )
              continue;

            return true;
          }

          return false;
        }).length > 0;

      // if (showAlert && state.commonState.withInternet)
      //   store.dispatch(
      //     commonSlice.actions.showAlert({
      //       title: "Download concluído.",
      //       description: "",
      //       show: true,
      //     })
      //   );
    }

    if (deleteContentReference.match(action)) {
      var content = state.contentState.allContents.find((p) =>
        p.references?.find((r) => r.uid == action.payload)
      );
      var reference = content?.references?.find((p) => p.uid == action.payload);

      if (reference) {
        store.dispatch(
          commonSlice.actions.showAlert({
            title: content?.title ?? "",
            description: `Deseja excluir o download deste ${reference.format} de seu dispositivo?`,
            show: true,
            buttons: [
              {
                label: "Sim",
                callback: () => {
                  if (!reference) return;
                  store.dispatch(contentSlice.actions.updateAllContents(
                    state.contentState.allContents.map(item => ({ 
                      ...item,
                      references: item.references?.map(referenceItem => {
                        if (reference && reference.uid === referenceItem.uid) {
                          return { 
                            ...referenceItem,
                            downloadProgress: 0,
                          }
                        }
                        return referenceItem
                      })
                    }))
                  ))
                  store.dispatch(internalDeleteContentReference(reference.uid))
                  store.dispatch(downloadedContents());
                }
              },
              {
                label: "Não",
              },
            ],
          })
        );
      }
    }

    if (searchAndSubscribeTag.match(action)) {
      store
        .dispatch(subscribeTag(action.payload))
        .unwrap()
        .then((tag) => {
          store.dispatch(
            commonSlice.actions.showAlert({
              title: "Importação de lista",
              description: "Lista importada com sucesso.",
              show: true,
            })
          );
          store.dispatch(loadUserData());
          store.dispatch(loadUserDataShared());
          store.dispatch(loadTags());
          store.dispatch(loadSharedTags());
          // store.dispatch(editTagByUid(tag.uid));
          store.dispatch(commonSlice.actions.changeRoute('/library/options'));
          setTimeout(() => {
            store.dispatch(
              commonSlice.actions.showAlert({
                title: "Importação de lista",
                description: "Lista importada com sucesso.",
                show: false,
              })
            );
          }, 3000)
        })
        .catch((reason) => {
          store.dispatch(
            commonSlice.actions.showAlert({
              title: "Importação de lista",
              description:
                "Falha ao importar lista compartilhada. Verifique o código e tente novamente.",
              show: true,
            })
          );
        });
    }

    /// Share Code
    if (shareCode.match(action)) {
      const data = action.payload;
      const tag = store
        .getState()
        .userDataState.tags.find((p) => p.name === FavoritesInternalTag);
      store.dispatch(
        commonSlice.actions.showAlert({
          title: "Compartilhar lista de leitura",
          description:
            "Envie a URL para pessoas de sua instituição com quem deseja compartilhar a lista. <a href='https://bibliotecadigital#'>https://bibliotecadigital#</a>",
          show: true,
          buttons: [
            {
              label: "Copiar",
              // value: "true",
              // content: data
            },
          ],
        })
      );
    }

    //userdata

    if (
      loadUserData.fulfilled.match(action) ||
      loadUserDataShared.fulfilled.match(action)
    ) {
      action.payload
        .filter((p) => p.contextType == "ManagedContent")
        .forEach((remote) => {
          var found = state.contentState.allContents.find(
            (p) => p.uid == remote.contextUid
          );
          if (found) return;

          store.dispatch(contentDetail(remote.contextUid));
        });
    }

    return next(action);
  };

export default userDataSlice.reducer;
